module.exports = __webpack_public_path__ + "static/img/4.45b9238.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/4.png
// module id = Sppe
// module chunks = 0